<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card success-card">
          <div class="card-body green">You successfully edited this admin!</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Edit Admin</strong>
          </div>
          <b-form @submit.prevent="editAccount">
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label>First Name</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="adminUser.first_name"
                  placeholder="Enter first name of the admin"
                  name="first_name"
                  :class="{'has-error': errors.has('first_name')}"
                ></b-form-input>
                <span class="red">{{ errors.first('first_name') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>Last Name</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="adminUser.last_name"
                  placeholder="Enter last name of the admin"
                  name="last_name"
                  :class="{'has-error': errors.has('last_name')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('last_name') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label>Email</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="adminUser.email"
                  name="email"
                  placeholder="Enter the email of the admin"
                  :class="{'has-error': errors.has('email')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('email') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label>Level of Access</label>&nbsp;<router-link to="/level-access">See all</router-link>
                <div v-if="parseInt(admin.admin_id) === parseInt(this.$route.params.id)" class="label-text">Level {{admin.level}}</div>
                <b-form-radio-group
                  id="basicRadiosCustom"
                  value="1"
                  v-if="(parseInt(admin.admin_id) !== parseInt(this.$route.params.id)) && adminLoaded"
                  stacked>
                  <div class="custom-control custom-radio access-radio">
                    <input type="radio" name="customRadio" id="customRadio1" class="custom-control-input" v-model="adminUser.level" value="1" checked>
                    <label class="custom-control-label" for="customRadio1">Level 1<br /><span class="text-muted">The person who serves as the primary contact for the account. Owners and admins have all the same permissions.</span></label>
                  </div>
                  <div class="custom-control custom-radio access-radio">
                    <input type="radio" name="customRadio" id="customRadio2" class="custom-control-input" v-model="adminUser.level" value="2">
                    <label class="custom-control-label" for="customRadio2">Level 2<br /><span class="text-muted">Provides an all-access pass to the account. Admins can perform all actions in the account.</span></label>
                  </div>
                  <div class="custom-control custom-radio access-radio">
                    <input type="radio" name="customRadio" id="customRadio3" class="custom-control-input" v-model="adminUser.level" value="3">
                    <label class="custom-control-label" for="customRadio3">Level 3<br /><span class="text-muted">Allows a user to create and edit companies and devices. This user type can't alter admins.</span></label>
                  </div>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="form-actions">
            <b-button type="submit" name="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import getAdmin from '../../mixins/getAdmin'

export default {
  name: 'Register',
  mixins: [
    getAdmin
  ],
  data () {
    return {
      admin: {},
      adminLoaded: false,
      adminUser: {},
      success: false
    }
  },
  methods: {
    /**
     * Submits the form information to the backend API once submit button is pressed to edit the admins account. The information is passed through a validator to make sure they meet the required details.
     */
    editAccount: function () {
      let self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put(`${process.env.VUE_APP_API_URL}api/admins/${this.$route.params.id}`, {
            email: self.adminUser.email,
            first_name: self.adminUser.first_name,
            last_name: self.adminUser.last_name,
            level: self.adminUser.level
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.success = true
              window.scrollTo(0, 0)
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    },
    /**
     * Gets details on admin from backend API by id.
     */
    getAdminDetails: function () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/admins/${this.$route.params.id}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          self.adminUser = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  async mounted () {
    await this.getAdmin()
    await this.getAdminDetails()

    this.adminLoaded = true
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.label-text {
  color: #73818F;
}
</style>
